module.exports = __webpack_public_path__ + "70afdbefaf8d768e9371b60b243667e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TextAppLink/apps.png
// module id = 2039
// module chunks = 0 1